import { useUpdateSetJobInternalConfig } from "./useUpdateSetJobInternalConfig";
import { useSuccessToast } from "@/hooks/useSuccessToast";
import { UpdateJobInternalConfigRequest } from "@/types";

export const useJobInternalConfigSubmit = (
  jobInternalConfigId: string,
  successMessage: string,
) => {
  const { mutate, isPending } = useUpdateSetJobInternalConfig();
  const successToast = useSuccessToast();

  const handleSubmit = (
    data: UpdateJobInternalConfigRequest,
    callbacks?: { onSuccess?: () => void; onError?: () => void },
  ) => {
    mutate(
      { id: jobInternalConfigId, updateRequest: data },
      {
        onSuccess: () => {
          successToast({ description: successMessage });
          callbacks?.onSuccess?.();
        },
        onError: callbacks?.onError,
      },
    );
  };

  return { handleSubmit, isPending };
};
